import React from "react";
import { IconPhone, IconPhoneOff, IconX } from "@tabler/icons-react";
import { twMerge } from "tailwind-merge";
import type { CallState } from "../../store/@types/chat";

type ChatHeaderProps = {
  callState: CallState;
  onStartCall: () => void;
  onEndCall: () => void;
  onClose: () => void;
};

const CALL_STATUS_LABEL: Record<Exclude<CallState, "idle">, string> = {
  connecting: "Connecting...",
  listening: "Listening... speak now",
};

const ChatHeader: React.FC<ChatHeaderProps> = ({
  callState,
  onStartCall,
  onEndCall,
  onClose,
}) => {
  const isOnCall = callState !== "idle";

  return (
    <div className="rounded-t-2xl bg-[#0B1526]">
      <div className="flex items-start justify-between gap-3 px-5 pb-3 pt-4">
        <div>
          <p className="text-base font-semibold text-white">
            Corporate Setup AI
          </p>
          <p className="mt-0.5 text-xs text-slate-300">
            Ask about incorporation, compliance &amp; plans
          </p>
        </div>
        <div className="flex flex-none items-center gap-2">
          <button
            type="button"
            onClick={onStartCall}
            disabled={isOnCall}
            aria-label="Start voice call"
            className={twMerge(
              "flex h-8 w-8 items-center justify-center rounded-lg transition-colors",
              isOnCall
                ? "bg-emerald-500 text-white"
                : "bg-white/10 text-white hover:bg-white/20",
            )}
          >
            <IconPhone size={16} />
          </button>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close chat"
            className="flex h-8 w-8 items-center justify-center rounded-lg bg-white/10 text-white transition-colors hover:bg-white/20"
          >
            <IconX size={16} />
          </button>
        </div>
      </div>

      {isOnCall && (
        <div className="flex items-center justify-between border-t border-white/10 px-5 py-2.5">
          <span className="text-sm font-medium text-emerald-400">
            {CALL_STATUS_LABEL[callState]}
          </span>
          <button
            type="button"
            onClick={onEndCall}
            className="inline-flex items-center gap-1.5 rounded-full bg-red-500 px-3 py-1.5 text-xs font-semibold text-white transition-colors hover:bg-red-600"
          >
            <IconPhoneOff size={14} />
            End Call
          </button>
        </div>
      )}
    </div>
  );
};

export default ChatHeader;
